import { createFileRoute } from '@tanstack/react-router';
import { RequirePermission } from '../../../features/layout/RequirePermission';
import { z } from 'zod';
import { UsersPage } from '../../../features/admin/users/UsersPage';

const searchSchema = z.object({
  q: z.string().catch(''),
  page: z.number().int().min(1).catch(1),
  roleId: z.number().int().positive().optional().catch(undefined),
  active: z
    .preprocess((v) => (typeof v === 'boolean' ? String(v) : v), z.enum(['all', 'true', 'false']))
    .catch('all'),
});

export const Route = createFileRoute('/_authed/admin/users')({
  validateSearch: searchSchema,
  component: Guarded,
});

function UsersRoute(): React.JSX.Element {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <UsersPage search={search} onSearch={(next) => void navigate({ search: next })} />;
}

function Guarded(): React.JSX.Element {
  return (
    <RequirePermission permission="users.manage">
      <UsersRoute />
    </RequirePermission>
  );
}
